module.exports = __webpack_public_path__ + "assets/img/img213.0d52fb0f.png";